module.exports = __webpack_public_path__ + "img/develop.9aa6aca5.jpg";